import { render, staticRenderFns } from "./queryPsDrawBillInit.vue?vue&type=template&id=d5955680&scoped=true"
import script from "./queryPsDrawBillInit.vue?vue&type=script&lang=js"
export * from "./queryPsDrawBillInit.vue?vue&type=script&lang=js"
import style0 from "./queryPsDrawBillInit.vue?vue&type=style&index=0&id=d5955680&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5955680",
  null
  
)

export default component.exports